import { useEffect, useState } from "react"
import Input from "../../Input"
import { toast } from "react-toastify"

const IdleTime = ({ values, serverData }) => {
    const [timeList, setTimeList] = useState([])
    const [isFormOpen, setIsFormOpen] = useState(false)
    const [editingIndex, setEditingIndex] = useState(null)
    const [formTime, setFormTime] = useState("")
    const [formIconID, setFormIconID] = useState("")

    useEffect(() => {
        if (!values) return
        if (values?.timeList) {
            try {
                const parsed = Array.isArray(values.timeList) ? values.timeList : JSON.parse(values.timeList)
                setTimeList(parsed || [])
            } catch (err) {
                setTimeList(values.timeList || [])
            }
        }
    }, [values])
    const resetForm = () => {
        setFormTime("")
        setFormIconID("")
        setEditingIndex(null)
    }

    const openAddForm = () => {
        resetForm()
        setIsFormOpen(true)
    }

    const openEditForm = (index) => {
        const item = timeList[index]
        setIsFormOpen(true)
        setFormTime(item.time)
        setFormIconID(item.iconID)
        setEditingIndex(index)
    }

    const cancelForm = () => {
        setIsFormOpen(false)
        resetForm()
    }

    const handleAdd = () => {
        const time = (formTime || "").trim()
        const iconID = (formIconID || "").toString().trim()
        if (!time || !iconID) {
            toast.error("لطفا مقادیر خواسته شده را وارد کنید")
            return
        }
        if (timeList.find((r) => r.time === time)) {
            toast.error("رنک با این نام قبلا توسط شما اضافه شده است")
            return
        }
        setTimeList((prev) => [...(prev || []), { time, iconID }])
        setIsFormOpen(false)
        resetForm()
    }

    const handleEdit = () => {
        const time = (formTime || "").trim()
        const iconID = (formIconID || "").toString().trim()
        if (!time || !iconID) {
            toast.error("لطفا مقادیر خواسته شده را وارد کنید")
            return
        }
        const nameTakenByOther = timeList.some((r, i) => i !== editingIndex && r.time === time)
        if (nameTakenByOther) {
            toast.error("رنک با این نام قبلا توسط شما اضافه شده است")
            return
        }
        setTimeList((prev) => {
            const next = [...prev]
            next[editingIndex] = { time, iconID }
            return next
        })
        setIsFormOpen(false)
        resetForm()
    }

    const handleDelete = () => {
        setTimeList((prev) => prev.filter((_, i) => i !== editingIndex))
        setIsFormOpen(false)
        resetForm()
    }
    return (
        <div className="mx-14 h-full">
            <input name={`idleTime-timeList`} className="hidden" value={JSON.stringify(timeList)} />
            <h6 className="flex justify-center">تایم بیکاری</h6>
            <div>
                <Input
                    type="text"
                    label="ایدی رنک ها برای چشم پوشی"
                    name="idleTime-ignoreSgList"
                    placeholder="مثال: 1,2,3"
                    autoComplete="off"
                    defaultValue={values?.ignoreSgList}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <div className="flex">
                    {timeList?.map((item, index) => (
                        <div key={index}>
                            <span role="button" className="text-blue-400" onClick={() => openEditForm(index)}>
                                {item.time}{" "}
                            </span>
                            ,
                        </div>
                    ))}
                    <button id="rankButton" type="button" className="px-2 bg-gray-700 rounded-md" onClick={openAddForm}>
                        Add
                    </button>
                </div>
                {isFormOpen && (
                    <div>
                        <div id={`idleTime-sgInputsField`} className="flex justify-between place-items-center gap-5">
                            <div className="flex gap-5">
                                <div>
                                    <Input
                                        type="number"
                                        label="تایم به دقیقه"
                                        placeholder="time"
                                        autoComplete="off"
                                        dir="ltr"
                                        value={formTime}
                                        onChange={(e) => setFormTime(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <Input
                                        type="number"
                                        label="ایدی ایکون"
                                        value={formIconID}
                                        options={serverData?.iconList}
                                        placeholder="iconID"
                                        autoComplete="off"
                                        dir="ltr"
                                        onChange={(v) => setFormIconID(v)}
                                    />
                                </div>
                            </div>
                            {editingIndex === null ? (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={handleAdd}
                                    >
                                        اضافه
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        onClick={cancelForm}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            ) : (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={handleEdit}
                                    >
                                        ویرایش
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 danger justify-item-center mt-5 border-none"
                                        onClick={handleDelete}
                                    >
                                        حذف
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        onClick={cancelForm}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default IdleTime
